import React, {useEffect} from 'react';
import {useSettingContext} from "context/SettingContext";
import {useForm} from "hooks/useForm";
import {serviceSettingItem, serviceSettingSave} from "services/setting.service";
import {useFetchLanguageList} from "hooks/useFetch";
import {Checkbox, Col, Row} from "antd";
import {Button, Card, FormGroup} from "components/ui";
import {getIframeSrc, translate} from "utils/helpers";
import {FormInput, FormSelect, FormTextarea} from "components/ui/form";
import {FiMinus, FiPlus} from "react-icons/all";
import {FaWhatsapp} from "@react-icons/all-files/fa/FaWhatsapp";

function SettingMain(props) {
    const tab = 'general'
    const [languages, fetchLanguages] = useFetchLanguageList();
    const {translateKey} = useSettingContext();
    const {values, setField, setValues, setLoading, loading} = useForm({});

    const handleForm = (item = {}) => {
        const customForm = {
            language: item.language || '',
            map: item.map || '',
            theme_color: item.theme_color || '',
            emails: item.emails || [''],
            address: item.address || [''],
            phones: item.phones || [
                {number: null, whatsapp: false}
            ],
        };
        setValues({...customForm});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await serviceSettingSave(values, tab);
        setLoading(false);
    }

    const handleAction = (key, action, index = null) => {
        if (action === 'add') {
            setValues(prevState => {
                let value = [...prevState[key], ''];
                if (key === 'phones') value = [...prevState[key], {number: null, whatsapp: false}]
                return {
                    ...prevState,
                    [key]: value
                }
            })
        } else {
            const items = [...values[key]];
            items.splice(index, 1)
            values[key] = items;
            setValues(prevState => ({
                ...prevState,
                [key]: [...values[key]]
            }))
        }
    }

    const handleChangeArr = (value, index, key) => {
        const items = [...values[key]];
        items[index] = value;
        values[key] = items;
        setValues(prevState => ({
            ...prevState,
            [key]: [...values[key]]
        }))
    }

    const handleChangeObj = (value, index, key, field) => {
        const items = [...values[key]];
        const item = {...items[index]}
        item[field] = value;
        items[index] = item;
        values[key] = items;
        setValues(prevState => ({
            ...prevState,
            [key]: [...values[key]]
        }))
    }

    const fetchByKey = async () => {
        const res = await serviceSettingItem(tab);
        handleForm(res?.value)
    }

    useEffect(() => {
        if (tab) {
            fetchLanguages();
            fetchByKey();
        }
    }, [tab])


    return (
        <Card className={'lg:w-[500px]'} title={translate('crm.Sidebar.Main')}>
            <form onSubmit={handleSubmit}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <FormGroup
                            label={translate(translateKey + '.Label.SystemLanguage')}
                        >
                            <FormSelect
                                options={languages}
                                maxLength={60}
                                value={values?.language}
                                fieldNames={{label: 'name', value: 'code'}}
                                onChange={e => setField('language', e)}
                            />
                        </FormGroup>
                    </Col>

                    <Col span={24} className="space-y-1">
                        {values?.emails?.length > 0 && values.emails.map((i, index) => (
                            <FormGroup
                                key={index}
                                label={index === 0 ? translate(translateKey + '.Label.Email') : ''}
                                suffixClass={'!p-0'}
                                suffix={
                                    <>
                                        {index > 0 && (
                                            <button type={'button'} className="w-[32px] !h-[32px] btn btn--red !p-0 justify-center" property="red" onClick={() => handleAction('emails', 'remove', index)}>
                                                <FiMinus/>
                                            </button>
                                        )}
                                        {index === 0 && (
                                            <button type={'button'} className="w-[32px] !h-[32px] btn btn--primary !p-0 justify-center" onClick={() => handleAction('emails', 'add')}>
                                                <FiPlus/>
                                            </button>
                                        )}
                                    </>
                                }
                            >
                                <FormInput
                                    value={i}
                                    onChange={e => handleChangeArr(e, index, 'emails')}
                                />
                            </FormGroup>
                        ))}
                    </Col>

                    <Col span={24} className="space-y-1">
                        {values?.address?.length > 0 && values.address.map((i, index) => (
                            <FormGroup
                                key={index}
                                label={index === 0 ? translate(translateKey + '.Label.Address') : ''}
                                suffixClass={'!p-0'}
                                suffix={
                                    <>
                                        {index > 0 && (
                                            <button type={'button'} className="w-[32px] !h-[32px] btn btn--red !p-0 justify-center" property="red" onClick={() => handleAction('address', 'remove', index)}>
                                                <FiMinus/>
                                            </button>
                                        )}
                                        {index === 0 && (
                                            <button type={'button'} className="w-[32px] !h-[32px] btn btn--primary !p-0 justify-center" onClick={() => handleAction('address', 'add')}>
                                                <FiPlus/>
                                            </button>
                                        )}
                                    </>
                                }
                            >
                                <FormInput
                                    value={i}
                                    onChange={e => handleChangeArr(e, index, 'address')}
                                />
                            </FormGroup>
                        ))}
                    </Col>

                    <Col span={24} className="space-y-1">
                        {values?.phones?.length > 0 && values.phones.map((i, index) => (
                            <FormGroup
                                key={index}
                                label={index === 0 ? translate(translateKey + '.Label.Phone') : ''}
                                prefix={
                                    <Checkbox
                                        checked={i.whatsapp}
                                        value={true}
                                        onChange={e => handleChangeObj(e.target.checked, index, 'phones', 'whatsapp')}
                                    >
                                        <FaWhatsapp/>
                                    </Checkbox>
                                }
                                suffixClass={'!p-0'}
                                suffix={
                                    <>
                                        {index > 0 && (
                                            <button type={'button'} className="w-[32px] !h-[32px] btn btn--red !p-0 justify-center" property="red" onClick={() => handleAction('phones', 'remove', index)}>
                                                <FiMinus/>
                                            </button>
                                        )}
                                        {index === 0 && (
                                            <button type={'button'} className="w-[32px] !h-[32px] btn btn--primary !p-0 justify-center" onClick={() => handleAction('phones', 'add')}>
                                                <FiPlus/>
                                            </button>
                                        )}
                                    </>
                                }
                            >
                                <FormInput
                                    value={i.number}
                                    onChange={e => handleChangeObj(e, index, 'phones', 'number')}
                                />
                            </FormGroup>
                        ))}
                    </Col>

                    <Col span={24}>
                        <FormGroup
                            label={translate(translateKey + '.Label.Map')}
                            elementClass={'!h-auto'}
                        >
                            <FormTextarea
                                rows={7}
                                value={values?.map}
                                onChange={e => setField('map', getIframeSrc(e))}
                            />
                        </FormGroup>
                    </Col>

                    <Col span={24} className="!flex justify-end">
                        <Button loading={loading} type={'submit'}>
                            {translate('button.Save')}
                        </Button>
                    </Col>
                </Row>
            </form>
        </Card>
    );
}

export default SettingMain;
